import React from "react";

const Cards = ({ name, rating, para, img }) => {
  return (
    // <div className="border-primary border-2 rounded-md px-4 relative">
    <img className="w-full" src={img} alt="" />
  );
};

export default Cards;
